<template>
  <div class="mainbox" style="width: 100wh;">
    <div class="topbox clear">
       <!-- search-input start-->
     <!--   <el-form :inline="true" :model="input" class="demo-form-inline clearfix">
        <el-form-item label="加购时间：" class="tinp searchtime":class="{iconshow:showicon}">
           <el-date-picker value-format="yyyy-MM-dd"  v-model="input.time" type="date" placeholder="选择日期" @change="getList"  @mouseover.native="cleandataicon" @mouseout.native="cleandataicon" >
          </el-date-picker>
        </el-form-item>
        <el-form-item label="商品名称：" class="tinp">
            <el-input v-model="input.productName" placeholder="请输入商品名称" suffix-icon="el-icon-search" clearable @change="getList"></el-input>
        </el-form-item>
        <el-button type="primary" class="" size="small" icon="el-icon-search" @click="getList">搜索</el-button>
        </el-form> -->
       <!-- search-input end-->
    </div>
    <div class="butlbox clearfix">
       <el-button type="primary" disabled class="fr tijiao" size="small" v-loading.fullscreen.lock="fullscreenLoading" @click="submit" v-if="tableListlength == 0&&tnum==0">提交采购申请</el-button>
       <el-button type="primary" v-else class="fr tijiao" size="small" v-loading.fullscreen.lock="fullscreenLoading" @click="submit">提交采购申请</el-button>
       <el-button type="danger" style="margin-right: 20px" class="fr tijiao" size="small" v-loading.fullscreen.lock="fullscreenLoading" @click="delAllPro" v-if="tableListlength != 0">清空采购商品</el-button>
       <!-- <el-button type="primary" class="fr tijiao" size="small" @click="showAlert">点我显示</el-button> -->
       <!-- <alert ref="alert">我是一个确认框</alert> -->
      <!-- <el-button @click="submit" class="fr" type="primary" size="small" style="">提交购物单</el-button> -->
      <div class="msg ">
        <span>本月额度：{{ vMdmyedbillinfo.quotabudget == null?0:vMdmyedbillinfo.quotabudget|currency('￥') }}</span><span>本月已用额度：{{ vMdmyedbillinfo.alreadyamount == null?0:vMdmyedbillinfo.alreadyamount|currency('￥') }}</span>
        <!-- <span>本单额度：{{tableList.ntotaltaxmny==null?0:tableList.ntotaltaxmny|currency('￥')}}</span> -->
        剩余额度：<span style="color:red">{{ vMdmyedbillinfo.surplusamount==null?0:vMdmyedbillinfo.surplusamount|currency('￥') }}</span><span v-if="tableListlength != 0">总数量：<span style="color:red">{{tableList.nnjum}}</span></span>

         <!--<0?0:vMdmyedbillinfo.surplusamount <span>本月额度：{{ money.vchangerate|currency('￥') }}</span><span>本月已用额度：{{ money.nznum|currency('￥') }}</span><span>本单额度：{{ntotaltaxmny|currency('￥')}}</span>剩余额度：<span style="color:red">{{ blance<0?0:blance|currency('￥') }}</span> -->
      </div>
    </div>
    <div class="tablebox" style="width:100%;height:auto" :style="{width: width}">
      <table style="width:100%;text-align: center; border: 1px solid #56B8AA">
        <tr style="background: #56B8AA;height:50px; border: 1px solid #56B8AA; color:#fff">
          <!-- <th class="allckeck" style="background: #fff;width:60px">
            <div class="item-all-check">
              <span class="checkbox-btn item-check-btn" v-bind:class="{'checked':checked}" @click="toggleCheckAll">
               <span class="iconfont icon-duigou" style="font-size: 12px"></span>
                </span>
            </div>
          </th> -->
          <!-- tableTitle start -->
          <th><span class="">行号</span></th>
          <th><span class="">物料编码</span></th>
          <th><span class="">物料名称</span></th>
          <th><span class="">规格</span></th>
          <th><span class="">型号</span></th>
          <th><span class="">单位</span></th>
          <th><span class="">数量</span></th>
          <!-- <th><span class="">单价</span></th> -->
          <!-- <th><span class="">合计</span></th> -->
          <th><span class="">操作</span></th>
          <!-- tableTitle end -->
        </tr>
        <tr v-for="(item,index) in tableList.productList" style="height:40px"  ><!-- v-if="item.dr == '0' && item.pkPrabilB!=null" -->
         <!--  <td class=""  style="color: #fff;">
            <div class="list-item-check">
              <span class="checkbox-btn item-check-btn" v-bind:class="{'checked':item.checked=='1'}" @click="choose(item,index)">
                 <span class="iconfont icon-duigou gou" style="font-size: 12px"></span>
                </span>
            </div>
          </td> -->
          <!-- tableList start -->
          <td style="">{{ item.crowno }}</td>
          <td style="">{{ item.productCode }}</td>
          <td style="">{{ item.productName }}</td>
          <td style="">{{ item.wlspec }}</td>
          <td style="">{{ item.wltype }}</td>
          <td style="">{{ item.cunitname }}</td>
          <td style="">
           <!--  <el-input-number :step="item.boxnum" :min="item.boxnum" size="mini" v-model="item.nznum"  @change="ParamChange(index,false)"></el-input-number> -->
            <div class="my-input-number" style="width:168px;height:32px;display:flex;border: 1px solid #56b8aa;border-radius: 4px;margin: 0 auto;">
              <el-button type="primary" icon="el-icon-minus" size="mini" :disabled="item.nznum==item.boxnum" style=" " @click="reduce(item.boxnum,index,false)"></el-button>
              <input type="text" v-model="item.nznum" disabled="disabled" style="outline:none;width:80px;font-size:16px;text-align:center;border: 0px;background-color: #fff;">
              <el-button type="primary" icon="el-icon-plus" style=" "  size="mini" @click="add(item.boxnum,index,false)"></el-button>
             </div>
          </td>
          <!-- <td style="">{{ item.nprice|currency('￥') }}</td> -->
          <!-- <td style="">{{ item.ntaxmny|currency('￥') }}</td> -->
          <td style="" class="">
            <el-Button size="mini" type="danger"  :disabled="index==0&&tableList.productList.length==1" class="del" @click="dellist(index,item.pkPrabilB)">删行</el-Button>
          </td>
          <!-- tableList end -->
        </tr>
      </table>
       <div class="msgNone" v-if="tableListlength == 0" style="text-align: center;font-size: 15px;color: #333;margin-top: 20px">
        暂无数据
      </div>
    </div>
      <!-- model start -->

      <!-- model end -->
      <!-- 弹窗 start -->
      <MessageModel types="提示信息" :msg="msg" :msgShow="msgShow" :flag="modelFlag" :butmsg="butmsg" :butflag = "butflag" @modelmsg="returnMsg"></MessageModel>
      <div class="v-l" v-loading.fullscreen.lock="fullscreenLoading"></div>
    </div>
  </div>
</template>
<script>
import { setCookie, getCookie, delCookie } from '../../../static/js/cookie.js'
import { currency } from '../../utils/currency'
// import axios from 'axios'
export default {
  inject:['reload'],
  name: '',
  // components:{
  //   MessageModel
  // },
  data() {
    return {
      mesContent:'',
      methodName:'',
      productCode:'',
      tnum:0,
      flag:false,
      msgShow:false,
      modelFlag:false,
      modelFlag2:false,
      butflag:true,
      butflag2:true,
      msg:'',
      butmsg:'确认',
      butmsg2:'确认',
      nextFlag:false,
      agree:'',
      utilpath:'',
      eduFlag:false,
      moneyvalue:true,
      shouShow:false,
      fullscreenLoading:true,
      vMdmyedbillinfo:{
        quotabudget:0,
        alreadyamount:0,
        surplusamount:0
      },
      users:{},
      tableListlength:0,
      input: {
        storecode:'',
        time:'',
        productName:''
      }, //搜索框数据
      money:{},
      tableList: {}, //表格数据
      ntotaltaxmny: '', //本单额度
      checked: false, //全选状态
      blance: '', //余额
      user: {}, //本店额度
      width: '',
      showicon:false,
      addmethod:false
    }
  },
  watch: {
    addmethod: function () {
        // console.log("-=-=-=1111111111111-=-=-=-"+this.addmethod);
        this.tijiao(this.tableList);
      }
  },
  mounted() {
    this.users = JSON.parse(window.localStorage.getItem("userInfo"));
    this.utilpath = this.axios.defaults.baseURL;
   // 获取接口名
    this.InterfacePath = window.localStorage.getItem("InterfacePath");
  // 初始化
    this.init();
  },
  filters: { // 过滤
    currency: currency
  },
  destroyed (){
        sessionStorage.removeItem("goulist");
        sessionStorage.removeItem("heji");
        sessionStorage.removeItem("sou");
  },
  methods: {
    changedMes(){
      this.nextFlag = false;
      this.mesContent = 0;
      this.$message({
          showClose:true,
          message:'已取消',
          type:'succcess'
      })
    },
    agreeMes(){
      this.nextFlag = true;
    },
    closeModel(){
      this.nextFlag = false;
    },
    returnMsg(flag){
      this.modelFlag = false;
      if(flag){
             // console.log("---进来了！！！----"+this.methodName);
            if(this.methodName =='删除'){
              this.fullscreenLoading = true;
                var reqparams={
                  storecode:this.users.storecode,
                  prabill:JSON.stringify(this.tableList),
                  pkPrabilB:this.productCode
                }
                // console.log("---删除参数！！！----"+JSON.stringify(reqparams));
                this.$http.post(this.utilpath+'/delettePrabillB',reqparams,{emulateJSON:true,_timeout:600}).then((res)=>{
                // this.$http.post("/ktnapi/delettePrabillB",reqparams,{emulateJSON:true}).then((res)=>{
                // this.$post('/delettePrabillB",reqparams,{emulateJSON:true}).then((res)=>{
                // this.$http.post(this.InterfacePath+"/delettePrabillB",reqparams,{emulateJSON:true}).then((res)=>{
                    if(res.data.status == '0'){
                      this.reload();
                      this.fullscreenLoading = false;
                        this.$message({
                          showClose: true,
                          message: '删除成功！',
                          type: 'succcess'
                        });
                    }else{
                      this.fullscreenLoading = false;
                      this.modelFlag = true;
                      this.msgShow = true;
                      this.methodName = 'message';
                      this.msg = res.data.message;
                      this.butflag =false;
                      this.butmsg='知道了';
                    }
                }, (err) => {
                  this.fullscreenLoading = false;
                      this.modelFlag = true;
                      this.msgShow = false;
                      this.methodName = 'message';
                      this.msg = '连接删除门店请购单接口失败';
                      this.butflag =false;
                      this.butmsg='知道了';
                })
            }else if(this.methodName =='subpro'){
              this.tnum=1;
              this.addmethod = true;
              this.tijiao(this.tableList)
            }else if(this.methodName =='delAllPro'){
              this.fullscreenLoading = true;
              this.$http.post(this.utilpath+'/deletePrabillAll',{emulateJSON:true,_timeout:600}).then((res)=>{
                // this.$http.post("/ktnapi/delettePrabillB",reqparams,{emulateJSON:true}).then((res)=>{
                // this.$post('/delettePrabillB",reqparams,{emulateJSON:true}).then((res)=>{
                // this.$http.post(this.InterfacePath+"/delettePrabillB",reqparams,{emulateJSON:true}).then((res)=>{
                    if(res.data.status == '0'){
                      this.fullscreenLoading = false;

                        this.vMdmyedbillinfo.surplusamount = parseFloat(this.vMdmyedbillinfo.quotabudget) - parseFloat(this.vMdmyedbillinfo.alreadyamount) - 0;//余额
                        this.reload();
                        this.$message({
                          showClose: true,
                          message: '删除成功！',
                          type: 'succcess'
                        });
                    } else if(res.data.status == '9'){
                      this.fullscreenLoading =false;
                      this.$router.push({path:'/ui/login',query:{msg:9}});
                    } else{
                      this.fullscreenLoading = false;
                      this.modelFlag = true;
                      this.msgShow = true;
                      this.methodName = 'message';
                      this.msg = res.data.message;
                      this.butflag =false;
                      this.butmsg='知道了';
                    }
                }, (err) => {
                      this.fullscreenLoading = false;
                      this.modelFlag = true;
                      this.msgShow = false;
                      this.methodName = 'message';
                      this.msg = '连接删除门店所有请购单接口失败';
                      this.butflag =false;
                      this.butmsg='知道了';
                });
            }
      }else{
        this.fullscreenLoading = false;
        if(this.methodName =='subpro'){
          var money = 0;
          this.tableList.productList.forEach((item2) => {//遍历数据计算合计价格
            if(item2.shoptype != 3){

              money += (parseFloat(item2.nprice) * parseFloat(item2.nznum));
            }
            // console.log("数量"+item2.nznum);
          });
          this.tableList.ntotaltaxmny = money;//本单额度
          this.vMdmyedbillinfo.surplusamount = parseFloat(this.vMdmyedbillinfo.quotabudget) - parseFloat(this.vMdmyedbillinfo.alreadyamount) - parseFloat(money);//余额
          this.addmethod = false;
        };
        this.$message({
          showClose:true,
          message:'已取消',
          type:'succcess'
        })
      }
    },
    showAlert() {
        this.modelFlag = true;
        this.msg = '此操作将----，是否继续提交？';
    },
    cleandataicon(){
      if(this.input.time !=''){
        this.showicon = !this.showicon;
      }
      if(this.input.time == null){
        this.showicon = false;
      }
    },
    init() {
      this.width=document.documentElement.clientWidth - 220;
      // console.log("打印宽度" + this.width);
      var list = JSON.parse(sessionStorage.getItem("goulist"));
      this.input.storecode=this.users.storecode;
      this.getList();
        var sou=JSON.parse(sessionStorage.getItem("sou"));
        if(sou != null){
          this.input= sou
        }
      // 获取本店额度、已用额度和剩余额度
        this.user = JSON.parse(window.localStorage.getItem("userInfo"));
        var reqparam = {
          storecode:this.user.storecode
        }
        this.getMdmyedbillinfo();
    },
    //额度
    getMdmyedbillinfo(){
          var reparm ={storecode:this.users.storecode};
          // console.log("dayin 获取额度参数"+reparm.storecode);
          this.$http.post(this.utilpath+'/submittedQuota',reparm,{emulateJSON:true,_timeout:600}).then((res) => {
          // this.$http.post("/ktnapi/submittedQuota",reparm,{emulateJSON:true}).then((res) => {
          // this.$post("/submittedQuota",reparm,{emulateJSON:true}).then((res) => {
          // this.$http.post(this.InterfacePath+"/submittedQuota",reparm,{emulateJSON:true}).then((res) => {
            if(res.data.status == '0'){
                this.eduFlag = false;
                this.vMdmyedbillinfo=res.data.result;
                if(this.tableList.ntotaltaxmny!=null){
                    this.vMdmyedbillinfo.surplusamount = parseFloat(this.vMdmyedbillinfo.quotabudget) - parseFloat(this.vMdmyedbillinfo.alreadyamount) - parseFloat(this.tableList.ntotaltaxmny);//余额
                }
                this.fullscreenLoading =false;
            } else if(res.data.status == '9'){
              this.fullscreenLoading =false;
              this.$router.push({path:'/ui/login',query:{msg:9}});
            } else if(res.data.status == '-1'){
                  this.eduFlag = true;
                  this.vMdmyedbillinfo={
                    quotabudget:0,
                    alreadyamount:0,
                    surplusamount:0
                  },
                  this.moneyvalue = false;
                  this.$message({
                    showClose:true,
                    message:'没有获取到额度信息',
                    type:'info'
                  })
            }else{
              this.moneyvalue = false;
              this.modelFlag = true;
              this.msgShow = true;
              this.methodName = 'message';
              this.msg = res.data.message;
              this.butflag =false;
              this.butmsg='知道了';
            }
          }, (err) => {
              this.modelFlag = true;
              this.msgShow = false;
              this.methodName = 'message';
              this.msg = '获取门店额度接口失败';
              this.butflag =false;
              this.butmsg='知道了';
          });
    },
    getList(){
      this.fullscreenLoading=true;

      this.$http.post(this.utilpath+'/submittedAll',this.input,{emulateJSON:true,_timeout:6000}).then((res) => {
      // this.$http.post("/ktnapi/submittedAll",this.input,{emulateJSON:true}).then((res) => {
      // this.$post("/submittedAll",this.input,{emulateJSON:true}).then((res) => {
      // this.$http.post(this.InterfacePath+"/submittedAll",this.input,{emulateJSON:true}).then((res) => {
            if(res.data.status == '0'){
                this.fullscreenLoading=false;
                this.tableList = res.data.result;
                this.tableListlength=this.tableList.productList.length;
                // 遍历数据提取每种商品的合计
                var money = 0;
                this.tableList.productList.forEach((item2) => {//遍历数据计算合计价格
                   if(item2.shoptype != 3){

                    money += (parseFloat(item2.nprice) * parseFloat(item2.nznum));
                   }else{
                     console.log("三类商品数值："+JSON.stringify(item2))
                   }
                });
                this.tableList.ntotaltaxmny = money;//本单额度
                // console.log("-=-=-=-=-=-额度本单额度222"+JSON.stringify(this.tableList.ntotaltaxmny));
                this.getMdmyedbillinfo();
                // console.log("打印额度判断-=-=-"+JSON.stringify(this.vMdmyedbillinfo));
                }else if(res.data.status == '-1'){
                  this.fullscreenLoading=false;
                    this.tableList.productList=[];
                    this.vMdmyedbillinfo.surplusamount =0;
                } else if(res.data.status == '9'){
                  this.fullscreenLoading =false;
                  this.$router.push({path:'/ui/login',query:{msg:9}});
                } else{
                  this.fullscreenLoading=false;
                  this.modelFlag = true;
                  this.msgShow = true;
                  this.methodName = 'message';
                  this.msg = res.data.message;
                  this.butflag =false;
                  this.butmsg='知道了';
           }
          }, (err) => {
            this.fullscreenLoading=false;
            this.modelFlag = true;
            this.msgShow = false;
            this.methodName = 'message';
            this.msg = '连接查询门店请购单接口失败'+err;
            this.butflag =false;
            this.butmsg='知道了';
          });
    },
    dellist(index,id) { //删除数据
      // console.log("删除打印id"+id)
      this.productCode=id;
        this.methodName = '删除';
        this.modelFlag = true;
        this.msgShow = false;
        this.butflag = true;
        this.butmsg='确认';
        this.msg = '此操作会将该行删除，是否继续执行？';
    },
    delAllPro(){
        this.methodName = 'delAllPro';
        this.modelFlag = true;
        this.msgShow = false;
        this.butflag = true;
        this.butmsg='确认';
        this.msg = '车操作将删除下面的所有商品，是否继续?';
    },
    submit() { //提交订单
          if(this.vMdmyedbillinfo.surplusamount<0&&!this.eduFlag){
               // this.$confirm('本店的可用额度不足，是否继续提交?', '提示', {
               //    confirmButtonText: '确定',
               //    cancelButtonText: '取消',
               //    type: 'warning'
               //  }).then(() => {
                    // this.tijiao(this.tableList);
                    this.methodName = 'subpro';
                    this.modelFlag = true;
                    this.msgShow = false;
                    this.butflag = true;
                    this.butmsg='确认';
                    this.msg = '本店的可用额度不足，是否继续提交?';
                    // this.tijiao(this.tableList);
                // }).catch(() => {
                  // yue = false;
                   // 遍历数据提取每种商品的合计


                // });
          }else if(this.eduFlag){
            this.methodName = 'eduFlag';
            this.modelFlag = true;
            this.msgShow = false;
            this.butflag = false;
            this.butmsg='知道了';
            this.msg = '本门店没有额度，请通知总部下发';
          }else{
            this.tnum=1;
            this.fullscreenLoading = true;
            this.tijiao(this.tableList);
          }
    },
    tijiao(reqparams){
      reqparams.quotabudget = this.vMdmyedbillinfo.quotabudget;
      reqparams.alreadyamount = this.vMdmyedbillinfo.alreadyamount;
      // 遍历数据提取每种商品的合计
      var money = 0;
      this.tableList.productList.forEach((item2) => {//遍历数据计算合计价格
        if(item2.shoptype != 3){

          money += (parseFloat(item2.nprice) * parseFloat(item2.nznum));
        }
      });
      this.tableList.ntotaltaxmny = money;//本单额度
      this.vMdmyedbillinfo.surplusamount = parseFloat(this.vMdmyedbillinfo.quotabudget) - parseFloat(this.vMdmyedbillinfo.alreadyamount) - parseFloat(money);
      reqparams.surplusamount=money
      var pram = {
        prabill : JSON.stringify(reqparams)
      };
        // this.$http.post('/ktnapi/updateQgdfbillstatus',pram,{emulateJSON:true}).then((res) => {
        // this.$qs.stringify(pram);
        // this.$post("/updateQgdfbillstatus", this.$qs.stringify(pram),{emulateJSON:true}).then((res) => {
        this.$http.post(this.utilpath+'/updateQgdfbillstatus',pram,{emulateJSON:true,_timeout:600}).then((res) => {
                if(res.data.status == '0'){
                    // window.location.reload();
                    this.$message({
                      showClose: true,
                      message: '提交成功！',
                      type: 'succcess'
                    });
                    this.reload();
                    this.fullscreenLoading = false;
                  } else if(res.data.status == '9'){
                    this.fullscreenLoading =false;
                    this.$router.push({path:'/ui/login',query:{msg:9}});
                  } else{
                    this.fullscreenLoading = false
                    this.modelFlag = true;
                    this.msgShow = true;
                    this.methodName = 'message';
                    this.msg = res.data.message;
                    this.butflag =false;
                    this.butmsg='知道了';
                  }
        }, (err) => {
                    this.fullscreenLoading = false
                    this.msgShow = false;
                    this.modelFlag = true;
                    this.methodName = 'message';
                    this.msg = '连接提交接口失败';
                    this.butflag =false;
                    this.butmsg='知道了';
                    this.reload();
                    // 遍历数据提取每种商品的合计
                    var money = 0;
                    this.tableList.productList.forEach((item2) => {//遍历数据计算合计价格
                      if(item2.shoptype != 3){

                        money += (parseFloat(item2.nprice) * parseFloat(item2.nznum));
                      }
                    });
                    this.tableList.ntotaltaxmny = money;//本单额度
                    this.vMdmyedbillinfo.surplusamount = parseFloat(this.vMdmyedbillinfo.quotabudget) - parseFloat(this.vMdmyedbillinfo.alreadyamount) - parseFloat(money);//余额
        });
    },
    // 单选点击事件
    choose(item, index) {
      item.checked = item.checked == "1" ? '0' : '1';
      this.tableList.productList.forEach((data) => {
        if (data.checked != '1') {
          this.checked = false;
          return;
        }
      })
      var money = 0;
      this.tableList.productList.forEach((item2) => {//遍历数据计算合计价格
        if (item2.checked == '1') {
          money += (parseFloat(item2.nprice) * parseFloat(item2.nznum));
        };
      });
      this.ntotaltaxmny = money;
      this.blance = parseFloat(this.user.amount) - parseFloat(this.user.Surplus) - parseFloat(this.ntotaltaxmny);
      // this.blance = parseFloat(this.money.vchangerate) - parseFloat(this.money.nznum) - parseFloat(this.ntotaltaxmny);
       // sessionStorage.setItem("heji",money);
       // sessionStorage.setItem("goulist",JSON.stringify(this.tableList));
    },
    // 增加
      add(num,index,numfalg){
        // console.log("打印相加数："+num);
        // console.log("打印数："+this.tableList.productList[index].nznum);
         this.tableList.productList[index].nznum=parseInt(this.tableList.productList[index].nznum)+parseInt(num);
         this.tableList.nnjum=parseInt(this.tableList.nnjum)+parseInt(num);
         this.ParamChange(index,numfalg);
      },
      // 减少
      reduce(num,index,numfalg){
        // console.log("1打印当前数值："+this.tableList.productList[index].nznum)
         if(this.tableList.productList[index].nznum==num){
            this.tableList.productList[index].nznum=num;
         }else{
            this.tableList.productList[index].nznum-=num;
            this.tableList.nnjum=parseInt(this.tableList.nnjum)-parseInt(num);
         }
        // console.log("2打印当前数值："+this.tableList.productList[index].nznum)
        this.ParamChange(index,numfalg);
    },
    ParamChange(index,numfalg){//数量变更事件
      // console.log("是否进来？打印数值变化："+index+"-=-=-=-"+numfalg);
      this.tableList.productList[index].nznum <0?0:this.tableList.productList[index].nznum;
      this.tableList.productList[index].ntaxmny = (parseFloat(this.tableList.productList[index].nprice) * parseFloat(this.tableList.productList[index].nznum));

      var money = 0;
      this.tableList.productList.forEach((item2) => {//遍历数据计算合计价格
        // if (item2.checked == '1') {
        //   money += (parseFloat(item2.nprice) * parseFloat(item2.nznum));
        // };
          if(item2.shoptype != 3){

            money += (parseFloat(item2.nprice) * parseFloat(item2.nznum));
          }
        // console.log("数量"+item2.nznum);
      });
      this.tableList.ntotaltaxmny = money;//本单额度
      this.vMdmyedbillinfo.surplusamount = parseFloat(this.vMdmyedbillinfo.quotabudget) - parseFloat(this.vMdmyedbillinfo.alreadyamount) - parseFloat(money);//余额
      sessionStorage.setItem("heji",money);
      sessionStorage.setItem("goulist",JSON.stringify(this.tableList));
    },
    // 全选点击事件
    toggleCheckAll() {
      this.checked = !this.checked
      this.tableList.productList.forEach((item) => {
        // console.log(this.checked);
        if (this.checked) {
          this.$set(item, 'checked', '1');
        } else {
          this.$set(item, 'checked', '0');
        }
        // sessionStorage.setItem("goulist",JSON.stringify(this.tableList));
      });
      var money = 0;
      this.tableList.productList.forEach((item2) => {
        if (item2.checked == '1') {
          money += (parseFloat(item2.nprice) * parseFloat(item2.nznum));
        };
      });
      // 计算
      this.ntotaltaxmny = money;
      // 计算剩余额度
      this.blance = parseFloat(this.user.amount) - parseFloat(this.user.Surplus) - parseFloat(this.ntotaltaxmny);
    },
    onParamChange() {//搜索条件变更
      this.getList();
    }
  }
}

</script>
<style scoped>
</style>



// WEBPACK FOOTER //
// src/views/order/tijiao.vue